<!-- 创建时间2023/06/16 15:17:36 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：能力标签 -->
<template>
  <div>
    <yxt-tag
      class="mr8 mb8"
      v-for="item in tags"
      :key="item.id"
      :closable="!disabled"
      :disable-transitions="false"
      @close="close(item)"
    >
      {{ item.name }}
    </yxt-tag>
    <span v-if="disabled && tags.length === 0">--</span>
    <yxt-button v-else-if="!disabled" type="primary" @click="select">{{ $t('pc_biz_select_ability'/** 选择能力 */) }}</yxt-button>

    <yxt-drawer
      :title="$t('pc_biz_select_ability'/** 选择能力 */)"
      size="960px"
      destroy-on-close
      :visible.sync="visible"
    >
      <yxtbiz-ability-selector
        ref="selector"
        :selectedData.sync="list"
        :limit="20"
      >
      </yxtbiz-ability-selector>
      <div slot="footer">
        <yxt-button plain @click="cancel">{{ $t('pc_biz_comment_cancel'/** 取消 */) }}</yxt-button>
        <yxt-button type="primary" @click="confirm">{{ $t('pc_biz_common_btn_sure'/** 确定 */) }}</yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>

<script>
export default {
  name: 'form-skill-tag',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      list: []
    };
  },
  computed: {
    tags: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      }
    }
  },
  methods: {
    close(obj) {
      const index = this.tags.findIndex(item => item.id === obj.id);
      index > -1 && this.tags.splice(index, 1);
    },
    select() {
      this.list = [...this.tags];
      this.visible = true;
    },
    cancel() {
      this.visible = false;
    },
    confirm() {
      this.tags = [...this.list];
      this.visible = false;
    }
  }
};
</script>